import { useState } from 'react'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import { SwiperSlide } from 'swiper/react'
import { useTrans } from '@hooks/index'
import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { WContainer } from '@components/atoms'
import { CarouselCard } from '@components/molecules'
import { GenericSlider, CarouselGalleryModal, GenericSection } from '@components/organisms'
import styles from './Carousel.module.sass'

interface Props {
  item: MenuItemType
  variant?: 'default' | 'icon'
  theme?: GenericSectionThemeType
  className?: string
}

const Carousel = (props: Props) => {
  const { item = undefined, variant = 'default', theme = 'white', className = '' } = props

  const [modalIndex, setModalIndex] = useState<number>(null)

  return item?.children?.length ? (
    <>
      <GenericSection item={item} theme={theme} className={`${styles.root} ${className}`}>
        <GenericSlider
          id={`carousel_${item.pk}`}
          navigationPos="pagination"
          notch
          conf={{
            slidesPerView: 1,
            spaceBetween: 10,
            modules: [A11y, Navigation, Pagination],
            navigation: true,
            pagination: { clickable: true },
            breakpoints: {
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
            },
          }}
        >
          {item.children.map((x, index) => (
            <SwiperSlide key={x.pk}>
              <CarouselCard item={x} variant={variant} onClick={() => setModalIndex(index)} />
            </SwiperSlide>
          ))}
        </GenericSlider>
      </GenericSection>
      <CarouselGalleryModal
        id={`carousel-gallery-modal_${item.pk}`}
        open={modalIndex !== null}
        initialSlide={modalIndex}
        onClose={() => setModalIndex(null)}
        item={item}
      />
    </>
  ) : (
    <></>
  )
}

export default Carousel
